import { Sparkles } from 'lucide-react';
import { useMatch } from 'react-router-dom';
import { useRouteTitle } from '@/components/shell/route-title';
import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import { AssistantCard } from './assistant-card';

/**
 * "Pergunte ao troig" em toda tela (módulos §11): o mesmo assistente da Inteligência, num painel
 * lateral, sabendo a tela e o produto aberto — "qual a margem dele na Shopee?" já sabe quem é.
 */
export function AssistantSheet() {
  const title = useRouteTitle() ?? null;
  const product = useMatch('/produtos/:id');
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="sm">
          <Sparkles aria-hidden /> <span className="hidden sm:inline">Pergunte ao troig</span>
        </Button>
      </SheetTrigger>
      <SheetContent className="w-full overflow-y-auto sm:max-w-lg">
        <SheetHeader className="sr-only">
          <SheetTitle>Pergunte ao troig</SheetTitle>
          <SheetDescription>
            Perguntas sobre a operação, respondidas com os números do troig.
          </SheetDescription>
        </SheetHeader>
        <AssistantCard compact screen={{ title, productId: product?.params.id ?? null }} />
      </SheetContent>
    </Sheet>
  );
}
